import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Toolbar, { Item } from "devextreme-react/toolbar";
import Button from "devextreme-react/button";
import UserPanel from "../user-panel/UserPanel";
import HeaderNavigation from "../../common-components/header-navigation/HeaderNavigation";
import "./Header.scss";
import { Template } from "devextreme-react/core/template";
import { ThemeSwitcher } from "../theme-switcher/ThemeSwitcher";
import { useMediaQuery } from "react-responsive";

export default function Header() {
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [navVisible, setNavVisible] = useState(false);
  const [userDetails, setUserDetails] = useState(() =>
    JSON.parse(localStorage.getItem("userDetails"))
  );

  useEffect(() => {
    if (!isMobile) {
      setNavVisible(false); // Hide nav when switching to desktop
    }
  }, [isMobile]);

  useEffect(() => {
    const updateUserDetails = () => {
      setUserDetails(JSON.parse(localStorage.getItem("userDetails")));
    };

    window.addEventListener("userDetailsChanged", updateUserDetails);

    return () => {
      window.removeEventListener("userDetailsChanged", updateUserDetails);
    };
  }, []);

  return (
    <header className={"header-component sticky- top-0"}>
      <Toolbar className={"header-toolbar"}>
        {/* Hamburger Icon for mobile */}
        {isMobile && (
          <Item location={"before"}>
            <Button
              icon="menu"
              stylingMode="text"
              onClick={() => setNavVisible((prev) => !prev)}
            />
          </Item>
        )}

        {/* Logo (always before navigation on mobile) */}
        {["CCPInspector", "QCPInspector"].includes(userDetails?.role) ? (
          <Item location={"before"} cssClass={"header-logo"} visible={true}>
            <img
              src={`${process.env.REACT_APP_PUBLIC_URL}/logo.svg`}
              alt="Baader"
              style={{
                height: "26px",
                objectFit: "contain",
                marginRight: "24px",
              }}
            />
          </Item>
        ) : (
          <Item location={"before"} cssClass={"header-logo"} visible={true}>
            <Link to="/quality/fillet/overview">
              <img
                src={`${process.env.REACT_APP_PUBLIC_URL}/logo.svg`}
                alt="Baader"
                style={{
                  height: "26px",
                  objectFit: "contain",
                  marginRight: "24px",
                }}
              />
            </Link>
          </Item>
        )}

        {/* Navigation - only on larger screens or when the menu button is clicked on mobile */}
        {(isMobile && navVisible) || !isMobile ? (
          <Item
            location={"before"}
            cssClass={isMobile ? "mobile-nav-visible" : "desktop-nav-visible"}
          >
            <HeaderNavigation closeNav={() => setNavVisible(false)} />
          </Item>
        ) : null}

        {/* ThemeSwitcher */}
        <Item location={"after"}>
          <ThemeSwitcher />
        </Item>

        {/* User Panel */}
        <Item
          location="after"
          locateInMenu="auto"
          menuItemTemplate="userPanelTemplate"
          render={() => (
            <div className="flex items-center gap-2">
              <UserPanel menuMode="context" />
              <p className="mb-0 text-[#f9fafb]">
                {userDetails?.firstName + " " + userDetails?.lastName}
              </p>
            </div>
          )}
        />
        <Template name="userPanelTemplate">
          <UserPanel menuMode="list" />
        </Template>
      </Toolbar>
    </header>
  );
}
